module.exports = __webpack_public_path__ + "static/img/mont2.d0e12d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mont2.png
// module id = 9EIv
// module chunks = 0